const TickIcon = ({ height = 64, width = 64 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M27.87 44.74L47.68 24.93L44.46 21.78L27.87 38.37L19.47 29.97L16.32 33.12L27.87 44.74ZM32 60C28.1733 60 24.5567 59.265 21.15 57.795C17.7433 56.325 14.7683 54.3183 12.225 51.775C9.68167 49.2317 7.675 46.2567 6.205 42.85C4.735 39.4433 4 35.8267 4 32C4 28.1267 4.735 24.4867 6.205 21.08C7.675 17.6733 9.68167 14.71 12.225 12.19C14.7683 9.67 17.7433 7.675 21.15 6.205C24.5567 4.735 28.1733 4 32 4C35.8733 4 39.5133 4.735 42.92 6.205C46.3267 7.675 49.29 9.67 51.81 12.19C54.33 14.71 56.325 17.6733 57.795 21.08C59.265 24.4867 60 28.1267 60 32C60 35.8267 59.265 39.4433 57.795 42.85C56.325 46.2567 54.33 49.2317 51.81 51.775C49.29 54.3183 46.3267 56.325 42.92 57.795C39.5133 59.265 35.8733 60 32 60ZM32 55.8C38.6267 55.8 44.25 53.4783 48.87 48.835C53.49 44.1917 55.8 38.58 55.8 32C55.8 25.3733 53.49 19.75 48.87 15.13C44.25 10.51 38.6267 8.2 32 8.2C25.42 8.2 19.8083 10.51 15.165 15.13C10.5217 19.75 8.2 25.3733 8.2 32C8.2 38.58 10.5217 44.1917 15.165 48.835C19.8083 53.4783 25.42 55.8 32 55.8Z"
				fill="#64DC78"
			/>
		</svg>
	);
};

export default TickIcon;
